import {
  Editable,
  EditableInput,
  EditablePreview,
  Spinner,
  Wrap,
} from '@cardboard-ui/react';
import React, { useEffect } from 'react';

interface EditableTitleProps {
  title: string;
  onSubmit: (newTitle: string) => void;
  isDisabled: boolean;
  isLoading: boolean;
  autoFocus?: boolean;
}

export const EditableTitle = ({
  title,
  onSubmit,
  isDisabled,
  isLoading,
  autoFocus = false,
}: EditableTitleProps) => {
  const editableRef = React.useRef<HTMLDivElement>(null);
  const smartSubmit = (newTitle: string) => {
    if (newTitle !== title) {
      onSubmit(newTitle);
    }
  };

  useEffect(() => {
    if (editableRef.current && autoFocus) {
      editableRef.current.focus();
    }
  }, [editableRef, autoFocus]);

  return (
    <Editable
      key={title} // This forces an update, when the default value changes
      isDisabled={isDisabled}
      defaultValue={title}
      onSubmit={smartSubmit}
    >
      <Wrap>
        <EditablePreview
          ref={editableRef}
          title={title}
          wordBreak="break-all"
          noOfLines={1}
        />

        <EditableInput />

        {isLoading && <Spinner size="xs" alignSelf="center" />}
      </Wrap>
    </Editable>
  );
};
